// 刷新账户使用
import { refresh } from '@/common/api/system.js'
export default {
  data() {
    return {
      refreshLoginTimer: null
    }
  },
  computed: {
    isLoginBoolan() {
      return this.$store.state.isLogin
    }
  },
  watch: {
    isLoginBoolan(v, v1) { // v 新  v1 旧
      if (!v1 && v) this.refreshLogin()
      if (v1 && !v) clearInterval(this.refreshLoginTimer)
    }
  },
  methods: {
    refreshLogin(param = {}) {
      clearInterval(this.refreshLoginTimer)
      const UUID = param.UUID || this.$Cookies.get('UUID') || window.localStorage.getItem('UUID')
      if (!UUID) return
      this.refreshLoginTimer = setInterval(() => {
        refresh({ UUID }).then(([data, err, res]) => {
          // console.log('refreshLogin', new Date());
          if (err) { // 登录过期
            this.$Cookies.remove('UUID')
            this.$store.commit('LOGIN_OUT')
            this.$router.replace({ path: '/' })
            clearInterval(this.refreshLoginTimer)
          }
        })
        if (!this.$Cookies.get('UUID') && !window.localStorage.getItem('UUID') && this.isLoginBoolan) {
          this.$store.commit('LOGIN_OUT')
          this.$router.replace({ path: '/' })
          clearInterval(this.refreshLoginTimer)
        }
      }, 5 * 60 * 1000)
    }
  },
  destroyed() {
    clearInterval(this.refreshLoginTimer)
  }
}



// WEBPACK FOOTER //
// ./src/common/mixin/refreshLogin.js